import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-eproctor',
  templateUrl: './eproctor.component.html',
  styleUrls: ['./eproctor.component.scss']
})
export class EproctorComponent implements OnInit {

  public isEnabled: boolean = false;

  constructor(
    public dataSvc: DataService
  ) { }

  ngOnInit() {
      this.isEnabled = this.dataSvc.currentExam().Session.EnableEProctoring;
      if (this.isEnabled) {
        if (this.dataSvc.getParameterByName("eproctored") == "1") 
        {
          // 
        }
        else 
        {
          this.redirectUrl();
        }
      }
  }

  redirectUrl() {
    let options = 0;
    let session = this.dataSvc.currentExam().Session;

    if (session.EnableDeskCheck) { options += 1; }
    if (session.EnableIDCheck) { options += 2; }
    if (session.EnableTermsCheck) { options += 4; }

    var url = this.dataSvc.eproctUrl.replace(/\/$/, '') + "/exam/";
    url += session.ScheduleId + "/";
    url += session.SessionId + "/";
    url += session.CandidateId + "/";
    url += encodeURIComponent(this.dataSvc.currentUser.Username) + "/";
    url += options + "/1";
    url += "?returnUrl=" + encodeURIComponent(window.location.href);
    
    window.location.href = url;
  }
}
